import { render, staticRenderFns } from "./ExamDataStudent.vue?vue&type=template&id=6582c118&scoped=true&"
import script from "./ExamDataStudent.vue?vue&type=script&lang=js&"
export * from "./ExamDataStudent.vue?vue&type=script&lang=js&"
import style0 from "./ExamDataStudent.vue?vue&type=style&index=0&id=6582c118&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582c118",
  null
  
)

export default component.exports